<template>
	<div class="flex">
		<div v-for="(item) in buttonauth" :key="item.code">
			<el-button v-if="type == 'button'" type="info" size="mini" style="margin-left: 10px;" @click="buttonauthClick(item.code)">{{item.name}}</el-button>
			<el-radio-button v-if="type == 'radioButton'" :label="item.code" >{{item.name}}</el-radio-button>
		</div>
	</div>
</template>
<style scoped>

</style>

<script>
	export default {
		props: {
			code: {
				default: () => {
					return null
				}
			},
			type: {
				default: () => {
					return 'button'
				}
			},
		},
		data() {
			return {
				buttonauth:[]
			}
		},
		created() {

		},
		mounted() {
			this.$api.buttonauth.getauthdata({code:this.code}).then((res)=>{
				this.buttonauth = res
			})
		},
		watch: {

		},
		computed: {
			
		},

		methods: {
			buttonauthClick(code){
				this.$emit('buttonauthClick',code)
			}
		},
		components: {

		}
	}
</script>